<template>
  <v-container>
    <!-- BOC:[breadcrumbs] -->
    <ABreadcrumb :items="breadcrumbs"></ABreadcrumb>
    <!-- EOC -->
    <v-card class="mx-auto pa-3" max-width="800" outlined min-height="200">
      <v-row class="mb-3">
        <v-col>
          <h2>Institution Info</h2>
        </v-col>
        <!-- <v-col cols="12" sm="6">
          <div class="d-flex justify-center justify-sm-end">
            <div>
              <v-btn
                rounded
                color="primary"
                :to="{
                  name: 'PageEducatorInstitutionEdit',
                  params: { id: this.$route.params.id },
                }"
                large
              >
                Edit
              </v-btn>
            </div>
          </div>
        </v-col> -->
      </v-row>
      <ALoader :isLoading="api.isLoading"></ALoader>
      <Read v-if="!api.isLoading" :headers="headers" :data="institution" />
    </v-card>
  </v-container>
</template>
    
    <script>
import { mapState } from "vuex";
import Read from "../../components/Datatable/Read.vue";
export default {
  components: {
    Read,
  },
  computed: {
    size() {
      const size = { xs: "small", sm: "small", lg: "large", xl: "x-large" }[
        this.$vuetify.breakpoint.name
      ];
      return size ? { [size]: true } : {};
    },
    ...mapState({
      auth: (state) => state.auth.data,
    }),
  },
  // computed: mapState({
  //     auth: (state) => state.auth.data,
  //   }),
  props: [
    //
  ],
  data: () => ({
    //BOC:[breadcrumbs]
    breadcrumbs: [],
    //EOC
    //BOC:[api]
    api: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    //EOC
    gameUrl: null,
    totalPage: 0,
    search: "",
    page: 1,
    pageCount: 0,
    itemsPerPage: 10,
    headers: [],
    data: [],
    institution: {},
  }),
  created() {
    this.breadcrumbs = [
      {
        text: "Dashboard",
        to: { name: "PageEducatorDashboard" },
        exact: true,
      },
      {
        text: "My institution",
        to: {
          name: "PageEducatorInstitutionDashboard",
          params: { id: this.$route.params.id },
        },
        exact: true,
      },
      {
        text: "Institution Info",
        to: {
          name: "PageEducatorInstitutionRead",
          params: { id: this.$route.params.id },
        },
        exact: true,
      },
    ]
    //
    this.headers = [
      { text: "Emblem", value: "institutionLogo" },
      { text: "Name", value: "name" },
      { text: "Address", value: "address" },
      { text: "Town", value: "town" },
      { text: "Postcode", value: "postcode" },
      { text: "Country", value: "country" },
      { text: "Type", value: "type" },
      // {
      //   text: "Id",
      //   align: "start",
      //   sortable: false,
      //   value: "id",
      // },
      { text: "Last Update", value: "timestampUpdated" },
    ]
    //
    this.api.method = "GET";
    this.api.url =
      this.$api.servers.sso +
      "/api/v1/" +
      this.$_getLocale() +
      "/educator/institution/" +
      this.$route.params.id;

    this.api.callbackReset = () => {
      this.api.isLoading = true;
      this.api.isError = false;
    };

    this.api.callbackError = (e) => {
      this.api.isLoading = false;
      this.api.isError = true;
      this.api.error = e;
    };

    this.api.callbackSuccess = (resp) => {
      this.api.isLoading = false;
      this.institution = resp;
      this.data.push(this.institution);
      //this.breadcrumbs[1].text = resp.name;
    };

    //EOC
    this.gameUrl = `${process.env.VUE_APP_URL_WEB_GAME}/en/access?code=${this.auth.Group.code}`;
  },
  mounted() {
    this.$api.fetch(this.api);
  },
  methods: {
    //
  },
};
</script>
<style scoped>
.menu-item {
  border: 1px solid black;
  margin: 3px;
}
.form-content {
  width: 600px !important;
}
</style>